import { GlobalModalService } from "./../../core/services/global-modal.service";
import { Component } from "@angular/core";
import { RouterService } from "src/app/services/router/router.service";
import { TabStats, TabStatsService } from "../../core/services/tab-stats.service";
import { BehaviorSubject } from "rxjs";
import { Tab } from "@core/models/types";
import { TabUtilsService } from "src/app/services/tab-utils.service";
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
  selector: "bpc-main-layout",
  templateUrl: "./main-layout.component.html",
  styleUrl: "./main-layout.component.scss",
})
export class MainLayoutComponent {
  navigateToTab(tab: Tab) {
    this.routerService.navigateToTab(tab);
  }

  get currentTabIndex() {
    return this.routerService.currentTabIndex;
  }

  get isMobile(): boolean {
    return false;
  }

  get onAvailableUserTabs() {
    return this.routerService.onAvailableUserTabs();
  }

  get isTablet(){
    return this.deviceDetectorService.isTablet();
  }

  tabStats$: BehaviorSubject<TabStats | undefined>;

  constructor(
    private routerService: RouterService,
    public globalModalService: GlobalModalService,
    private tabStatsService: TabStatsService,
    private tabUtilsService: TabUtilsService,
    private deviceDetectorService: DeviceDetectorService,
  ) {
    this.tabStats$ = this.tabStatsService.tabStatistics;

    this.tabUtilsService.refreshData.subscribe(()=>{
      if (this.isTablet)
        scrollTo(0, -500);
    });
  }
}
